// Docket Alarm "common" javascript library. Code that is generally used across all page.
// Statistics Views Library, used by analytics pages.

// Initialize Masonry when needed
var masonry_loaded = false;
async function masonry_load(done) {
	if(masonry_loaded) {
		done(masonry_loaded);
	} else {
		// Lazy loading Masonry
		const masonryModule = await import('masonry-layout');
		const Masonry = masonryModule.default;
		masonry_loaded = Masonry;
		done(Masonry);
	}
}
window.masonry_load = masonry_load;

import * as stats_views_js from "./stats_views.js";
window.stats_views_js = stats_views_js;
